// Application and Payment Deadline Configuration
// Format: "YYYY-MM-DD HH:mm:ss" (24-hour format)
// Set to null to disable the deadline check

export const APPLICATION_START_DATE = "2025-11-01 00:00:00";
export const APPLICATION_END_DATE = "2026-03-05 23:59:59";

// Helper function to check if current time is within the allowed period
export const isApplicationPeriodActive = () => {
  const now = new Date();

  // If start date is set, check if we're past it
  if (APPLICATION_START_DATE) {
    const startDate = new Date(APPLICATION_START_DATE);
    if (now < startDate) {
      return false;
    }
  }

  // If end date is set, check if we're past it
  if (APPLICATION_END_DATE) {
    const endDate = new Date(APPLICATION_END_DATE);
    if (now > endDate) {
      return false;
    }
  }

  return true;
};
